import { InvoiceFileNameEnum } from '@sr-sdks/api-sdk-axios';
import type {
  StatementFileNameBySource,
  StatementFileSource,
} from '../helpers/statementFiles';
import downloadApi from './downloadApi';

/**
 * The download each statement file goes through, for every table. An invoice
 * row can be royalty or disbursement, so invoices route by file: royalty files
 * use `royaltyInvoice`, the seam APP-2140's confirm toast hooks into.
 */
export const STATEMENT_FILE_DOWNLOADS: {
  [S in StatementFileSource]: (
    fileName: StatementFileNameBySource[S],
    entityId: string,
  ) => Promise<Blob>;
} = {
  invoice: (fileName, entityId) =>
    fileName === InvoiceFileNameEnum.DisbursementStatementPdf
      ? downloadApi.paymentStatement(fileName, entityId)
      : downloadApi.royaltyInvoice(fileName, entityId),
  statement: (fileName, entityId) =>
    downloadApi.royaltyStatement(fileName, entityId),
};
